export const SerasaBuscaEntity ={
    codparc:0
    ,cnpj:''  
}